import { MonoTypeOperatorFunction, Observable } from "rxjs";

export function untilComplete<T>(notifier: Observable<any>): MonoTypeOperatorFunction<T> {
    return (source) =>
        new Observable((subscriber) => {
            const subscription = notifier.subscribe({
                error: (err) => {
                    subscriber.error(err);
                },
                complete: () => {
                    subscriber.complete();
                }
            });

            if (!subscriber.closed) {
                source.subscribe(subscriber);
            }

            return () => {
                subscriber.unsubscribe();
                subscription.unsubscribe();
            };
        });
}
